import {
    calculateDurations,
    calculateErGpRemaining,
    removeDefaultDates,
    setDefaultEvent,
    setNumericMax,
    updateErGpRemaining,
    updateExecSummaryProjectSchedule
} from './mprExecutiveSummary';
import {loadApprovals, rejectApprovals, saveApproval} from './approvals';
import {displayFinalizedTag} from './all';
import revisedBaseEstimate from './revisedBaseEstimate';

export const SECTION_ID = 'BaseExecutiveSummary';
const pid = parseInt($('#Project_Pid').val());
const mid = -1;

export default function () {
    let $baseExecSum = $('#BaselineExecutiveSummaryModelForm');

    if ($baseExecSum.length) {
        //If the Base Executive Summary Exists,
        //  then this run some scripts

        //Clear Initial Values
        removeDefaultDates();
        setDefaultEvent();

        //Run Calculations
        calculateDurations();
        calculateErGpRemaining();
        calculateTotals();
        calculateVariance();

        //SetupEvents
        updateExecSummaryProjectSchedule();
        updateErGpRemaining();
        setNumericMax();
        RecalculateTotalsEvent();

        //Reload Approvals
        loadApprovals()
            .then(() => {
                attachApprovalEvents();
                displayFinalizedTag();
            });

        revisedBaseEstimate();
    }
}

const calculateTotals = function () {
    let $cest4                              = $('#CE_ST_4'),/*Project Cost Subtotal*/
        $brst4                              = $('#BR_ST_4'),/*Project Cost Subtotal*/
        $gmpcest                            = $('#GMP_CE_ST'),/*Potential GMP Profit Enhancements*/
        $gmpbrst                            = $('#GMP_BR_ST'),/*Potential GMP Profit Enhancements*/
        $gpscest                            = $('#GPS_CE_ST'),/*Gross Profit Summary*/
        $gpsbrst                            = $('#GPS_BR_ST'),/*Gross Profit Summary*/
        $ce1 = $('#OriginalEstimate'),
        $br1 = $('#OriginalRevision');

    /*Potential GMP Profit Enhancements*/
    $gmpcest.text(kendo.toString((parseFloat($('#FixedGeneralEstimates').val()) + parseFloat($('#LaborRateEstimates').val()) + parseFloat($('#InterCompanyEstimates')
        .val()) + parseFloat($('#OwnedEquipmentEstimates').val()) + parseFloat($('#Other45Estimates').val()) + parseFloat($('#Other46Estimates').val()) + parseFloat($('#Other47Estimates')
        .val())), '##,#.00'));
    $gmpbrst.text(kendo.toString((parseFloat($('#FixedGeneralRevisions').val()) + parseFloat($('#LaborRateRevisions').val()) + parseFloat($('#InterCompanyRevisions')
        .val()) + parseFloat($('#OwnedEquipmentRevisions').val()) + parseFloat($('#Other45Revisions').val()) + parseFloat($('#Other46Revisions').val()) + parseFloat($('#Other47Revisions')
        .val())), '##,#.00'));
    /*Gross Profit Summary*/
    $gpscest.text(kendo.toString((parseFloat($ce1.text().split(',').join('')) + parseFloat($gmpcest.text().split(',').join('')) - parseFloat($cest4.text().split(',').join(''))), '##,#.00'));
    $gpsbrst.text(kendo.toString((parseFloat($gmpbrst.text().split(',').join('')) - parseFloat($brst4.text().split(',').join(''))), '##,#.00'));

    //Calculate Percentages
    let denom = parseFloat($ce1.text().split(',').join('')) + parseFloat($gmpcest.text().split(',').join(''));
    if (denom !== 0)
        $('#GPS_CE_STperc').text((100 * parseFloat($gpscest.text().split(',').join('')) / denom).toFixed(2) + '%'); else $('#GPS_CE_STperc').text('0.00%');
    denom = parseFloat($ce1.text().split(',').join('')) + parseFloat($gmpbrst.text().split(',').join(''));
    if (denom !== 0)
        $('#GPS_BR_STperc').text((100 * parseFloat($gpsbrst.text().split(',').join('')) / denom).toFixed(2) + '%'); else $('#GPS_BR_STperc').text('0.00%');
    denom = parseFloat($('#mprGMP_V_ST').text().split(',').join(''));
    if (denom !== 0)
        $('#mprGPS_V_STperc').text((100 * parseFloat($('#mprGPS_V_ST').text().split(',').join('')) / denom).toFixed(2) + '%'); else $('#mprGPS_V_STperc').text('0.00%');

    //Calculate PCO Totals
    let approvedTotal = 0, pcoaTotal = 0, pcobTotal = 0, $approvals = $('.approvedCurrent'), $pcoas = $('.pcoaCurrent'), $pcobs = $('.pcobCurrent');

    $approvals.each(function (index, ele) {
        approvedTotal += parseFloat(ele.attributes.value.value);
    });

    $pcoas.each(function (index, ele) {
        pcoaTotal += parseFloat(ele.attributes.value.value);
    });
    $pcobs.each(function (index, ele) {
        pcobTotal += parseFloat(ele.attributes.value.value);
    });

    let currentContract = $('#currentContract').val() || 0;
    $('#approvedCurrentTotal').text(kendo.toString(approvedTotal, '##,#.00'));
    $('#pcoaCurrentTotal').text(kendo.toString(pcoaTotal, '##,#.00'));
    $('#pcobCurrentTotal').text(kendo.toString(pcobTotal, '##,#.00'));
    $('#pcoTotal').text(kendo.toString(pcoaTotal + pcobTotal, '##,#.00'));
    $('#totalContract').text(kendo.toString(parseFloat(currentContract) + pcoaTotal + pcobTotal, '##,#.00'));

};
const calculateVariance = function () {
    let $ce1            = $('#OriginalEstimate'),
        $gmpvst         = $('#mprGMP_V_ST'),
        $gpsvst         = $('#mprGPS_V_ST');
    /*3.0*/
    /*4.1*/
    $('#mprGMP_V_1').text(kendo.toString($('#FixedGeneralEstimates').val() - $('#FixedGeneralRevisions').val(), '##,#.00'));
    /*4.2*/
    $('#mprGMP_V_2').text(kendo.toString($('#LaborRateEstimates').val() - $('#LaborRateRevisions').val(), '##,#.00'));
    /*4.3*/
    $('#mprGMP_V_3').text(kendo.toString($('#InterCompanyEstimates').val() - $('#InterCompanyRevisions').val(), '##,#.00'));
    /*4.4*/
    $('#mprGMP_V_4').text(kendo.toString($('#OwnedEquipmentEstimates').val() - $('#OwnedEquipmentRevisions').val(), '##,#.00'));
    /*4.5*/
    $('#mprGMP_V_5').text(kendo.toString($('#Other45Estimates').val() - $('#Other45Revisions').val(), '##,#.00'));
    /*4.6*/
    $('#mprGMP_V_6').text(kendo.toString($('#Other46Estimates').val() - $('#Other46Revisions').val(), '##,#.00'));
    /*4.7*/
    $('#mprGMP_V_7').text(kendo.toString($('#Other47Estimates').val() - $('#Other47Revisions').val(), '##,#.00'));
    /*4.7 - SubTotal*/
    $gmpvst.text(kendo.toString($('#GMP_CE_ST').text().split(',').join('') - $('#GMP_BR_ST').text().split(',').join(''), '##,#.00'));
    /*5.0*/
    $gpsvst.text(kendo.toString($('#GPS_CE_ST').text().split(',').join('') - $('#GPS_BR_ST').text().split(',').join(''), '##,#.00'));

    //Calculate Percents
    let denom = parseFloat($ce1.text().split(',').join(''));
    denom = parseFloat($ce1.text().split(',').join('')) + parseFloat($gmpvst.text().split(',').join(''));
    if (denom !== 0) $('#mprGPS_V_STperc').text((100 * parseFloat($gpsvst.text().split(',').join('')) / denom).toFixed(2) + '%'); else $('#mprGPS_V_STperc').text('0.00%');
};

const RecalculateTotalsEvent = function () {
    let $inputs = $('#financialSumCard input[type=text]');

    if ($inputs.length) {
        $inputs.blur(function () {
            calculateTotals();
            calculateVariance();
        });
    }
};

export const attachApprovalEvents = function () {
    let $approvalBtns = $('[id^=mprExecSumApprovalBtn]'), $rejectApprovalBtn = $('#removeApprovals, #removeApprovalsUnlock');

    if ($approvalBtns.length) {
        $approvalBtns.click(function () {
            let id = this.id, role = id.split('_')[1];
            saveApproval(role)
                .then(function () {
                    reloadPage();
                })
                .catch((response) => {
                    //Approval Failed for some reason
                    console.error(response);
                });
        });
    }

    if ($rejectApprovalBtn.length) {
        $rejectApprovalBtn.click(function () {
            let unlock = this.id === 'removeApprovalsUnlock';
            rejectApprovals(SECTION_ID, {unlockForm: true}).then(function () {
                //Rejection Completed
                reloadPage();
            })
                .catch((response) => {
                    //Rejection Failed for some reason
                    console.error(response);
                });
        });
    }
};
const reloadPage = function () {
    $('#BaselineExecutiveSummaryModelForm').submit();
};
